import React, { useEffect, useRef, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import BreadScrumb from "../components/BreadScrumb";
import { CancelOrder, ViewOrderDetails } from "../apis/Api";
import { useParams } from "react-router-dom";
import { groupProductsByPhone } from "../utils/helper";
import toast from "react-hot-toast";
import Invoice from "../common/Invoice";
import { Loader } from "../common/Loader";
const OrderDetails = () => {
  const { order_token } = useParams();
  const [orders, setOrder] = useState([]);
  const [transformData, setTransformData] = useState([]);
  const [reason, setReason] = useState();
  const [trigger, setTrigger] = useState(0);
  const [orderStatus, setOrderStatus] = useState(orders.order_status);
  const [model, setModel] = useState(false);
  const [loading, setLoading] = useState(false);

  const getOrderSteps = (status) => [
    { title: "Order Placed", completed: status >= 0 },
    { title: "Order Accepted", completed: status >= 1 },
    { title: "Agent Assigned", completed: status >= 2 },
    { title: "Agent Out", completed: status >= 3 },
    { title: "Order Completed", completed: status >= 4 },
  ];

  const orderSteps = getOrderSteps(orders?.order_status || 0);

  const fetchOrderDetails = async () => {
    setLoading(true);
    try {
      const response = await ViewOrderDetails({ order_token: order_token });
      if (response) {
        setOrder(response.data);
        const value = groupProductsByPhone(response.data);
        setTransformData(value);
      }
    } catch (error) {
      console.log("error getting brand data", error);
    } finally {
      setLoading(false);
    }
  };

  const CancelOrderDetails = async () => {
    if (!reason) {
      toast.error("Please provide a reason.");
      return;
    }
    try {
      const response = await CancelOrder({
        order_token: orders.order_token,
        reason: "Customer Request",
      });

      if (response?.status === 200) {
        toast.success("Order cancelled successfully!");
        setTrigger((prev) => prev + 1);
        setModel(true);
        setReason("");
      } else {
        toast.error("Failed to cancel order.");
      }
    } catch (error) {
      toast.error("Error cancelling order.");
      console.error("Error:", error.message);
    }
  };
  useEffect(() => {
    fetchOrderDetails();
  }, [trigger]);

  if (loading) {
    return (
      <>
        <Header />
        <div className="container">
          <div className="row">
            <div
              className="col-md-12 d-flex justify-content-center flex-column align-items-center"
              style={{ minHeight: "80vh", backgroundColor: "white" }}
            >
              <Loader />
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Header />
      <div id="content" className="no-bottom no-top">
        <BreadScrumb
          title="Order History"
          Banner="/assets/images/background/3.webp"
        />
        <div className="container mt-4">
          <div className="row">
            <div className="d-flex justify-content-between">
              <span className="fw-bold" style={{ color: "#73b734" }}>
                Repair
              </span>
              <span style={{ color: "#73b734" }}>
                Order ID:{orders?.order_id}
              </span>
            </div>
            {orders && transformData && transformData.length > 0 ? (
              transformData.map((product, index) => (
                <div key={index} className="col-md-4 mb-4">
                  <div
                    className="card border-light p-3 shadow-sm"
                    style={{ borderTop: "4px solid #73b734" }}
                  >
                    <p className="text-muted mb-1">
                      Create Date: {orders.create_date}
                    </p>
                    <hr className="border-dark" />
                    <div className="d-flex justify-content-between">
                      <div className="">
                        <h6 className="fw-bold">{product.phone}</h6>
                        {/* <p className="text-muted">{product.color}</p> */}
                        <p className="text-muted">Genuine</p>

                      </div>
                      <img
                        style={{ height: "100px", objectFit: "contain" }}
                        src={product.url || "https://via.placeholder.com/50"}
                        alt={product.name}
                      />
                    </div>

                    <h6 className="fw-bold mt-2">Booked Repairs:</h6>

                    <p className="text-muted">
                      {product.products.map((data, i) => (
                        <div key={i}>{data.product_name}</div>
                      ))}
                    </p>
                  </div>
                </div>
              ))
            ) : (
              <p>No orders found.</p>
            )}
          </div>
        </div>

        <div className="container mt-4">
          <div className="row">
            <div className="col-md-8 mb-4">
              {orders.order_status === 5 ? (
                <div
                  className="card p-4 shadow-sm text-center"
                  style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "10px",
                    border: "1px solid red",
                  }}
                >
                  <h5 className="text-danger fw-bold">
                    Your Order Has Been Cancelled
                  </h5>
                  <p className="text-muted">
                    If you have any queries, please contact support.
                  </p>
                </div>
              ) : (
                <div
                  className="card p-4 shadow-sm"
                  style={{ backgroundColor: "#f8f9fa", borderRadius: "10px" }}
                >
                  <p className="fw-bold">
                    Status:{" "}
                    <span style={{ color: "#73b734" }}>
                      {orderSteps.find((step) => step.completed)?.title ||
                        "Pending"}
                    </span>
                  </p>
                  {orderSteps.map((step, index) => (
                    <div key={index} className="d-flex align-items-center mb-2">
                      <div
                        className="d-flex align-items-center justify-content-center rounded-circle"
                        style={{
                          width: "30px",
                          height: "30px",
                          border: `2px solid ${
                            step.completed ? "#73b734" : "#ccc"
                          }`,
                          backgroundColor: step.completed
                            ? "#73b734"
                            : "transparent",
                          transition: "all 0.4s ease-in-out",
                        }}
                      >
                        {step.completed && (
                          <i className="text-white fa fa-check"></i>
                        )}
                      </div>
                      <p
                        className={`mb-0 ms-2 ${
                          step.completed ? "fw-bold text-dark" : "text-muted"
                        }`}
                        style={{ transition: "color 0.4s ease-in-out" }}
                      >
                        {step.title}
                      </p>
                    </div>
                  ))}
                  {orders.order_status < 4 && (
                    <button
                      className="btn btn-light shadow-sm text-danger fw-bold mt-3"
                      style={{ border: "1px solid red", height: "40px" }}
                      data-bs-toggle="modal"
                      data-bs-target="#myModal"
                    >
                      Cancel
                    </button>
                  )}
                  {orders.order_status === 4 && (
                    <Invoice order={orders} transformedData={transformData} />
                  )}
                </div>
              )}
            </div>

            <div className="col-md-4">
              <div
                className="card p-4 shadow-sm"
                style={{ backgroundColor: "#f8f9fa", borderRadius: "10px" }}
              >
                <h5 className="fw-bold" style={{ color: "#73b734" }}>
                  Price Summary
                </h5>
                {transformData && transformData.length > 0
                  ? transformData.map((product, i) =>
                      product.products.map((data, i) => (
                        <div className="d-flex justify-content-between">
                          <span className="fw-bold">{data.product_name}</span>
                          <span>₹ {data.price}</span>
                        </div>
                      ))
                    )
                  : "Data not Found"}
                <hr />
                <h5 className="d-flex justify-content-between">
                  Total Price: <span>₹{orders.total_price}</span>{" "}
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />

      <div className="modal fade" id="myModal" tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            {/* Modal Header */}
            <div className="modal-header">
              <h5 className="modal-title" style={{ color: "#73b734" }}>
                Cancel Order
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body">
              <form>
                <div className="mb-3">
                  <label className="form-label">
                    Reason for Cancellation{" "}
                    <span className="text-danger">*</span>
                  </label>
                  <textarea
                    className="form-control border border-danger"
                    placeholder="Enter reason for cancellation"
                    value={reason}
                    onChange={(e) => {
                      setReason(e.target.value);
                    }}
                    rows="3"
                    required
                  ></textarea>
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-outline-success"
                data-bs-dismiss="modal"
                style={{ height: "40px", width: "80px" }}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn"
                style={{
                  backgroundColor: "#73b734",
                  color: "white",
                  height: "40px",
                  width: "80px",
                }}
                onClick={CancelOrderDetails}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OrderDetails;
